import { deserialize } from 'cerialize'

export class RbidosAccessAgentModel {
	@deserialize public id?: number
	@deserialize public infotecs_request_id: number
	@deserialize public last_name: string
	@deserialize public first_name: string
	@deserialize public middle_name: string
	@deserialize public internal_passport_series: string
	@deserialize public internal_passport_number: string
	@deserialize public internal_passport_issued: string
	@deserialize public internal_passport_issued_by: string
	@deserialize public internal_passport_issue_code: string
	@deserialize public position: string
	@deserialize public roles: string[]
	@deserialize public snils: string
	@deserialize public inn: string
	@deserialize public phone: string
	@deserialize public email: string
	@deserialize public required_fields: string[]
	@deserialize public without_middle_name: boolean
	@deserialize public auto_processing?: string
}
